/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const FinalReport = {

	getAllowedBasicData (context, onSuccess, onError, options) {
		Api.get(context,
			"/final-report/allowed-basic-data"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicDataByProjectCode (context, projectCode, onSuccess, onError, options) {
		Api.get(context,
			"/final-report/basic-data-by-project-code"
			+ "?projectCode=" + projectCode
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBasicDataList (context, ids, onSuccess, onError, options) {
		Api.get(context,
			"/final-report/basic-data-list"
			+ "?ids=" + ids
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/final-report/configuration"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCurrentState (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/final-report/current-state"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/final-report/data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPreviousVersionData (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/final-report/previous-version-data"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSendAndApprovalDates (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/final-report/send-and-approval-dates"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getVersionData (context, projectId, version, onSuccess, onError, options) {
		Api.get(context,
			"/final-report/version-data"
			+ "?projectId=" + projectId
			+ "&version=" + version
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postApprove (context, projectId, finalReportApprovalDTO, onSuccess, onError, options) {
		Api.post(context,
			"/final-report/approve"
			+ "?projectId=" + projectId
			, finalReportApprovalDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCancelCorrections (context, projectId, onSuccess, onError, options) {
		Api.post(context,
			"/final-report/cancel-corrections"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCostsExport (context, projectId, costsExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/final-report/costs-export"
			+ "?projectId=" + projectId
			, costsExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postData (context, projectId, data, onSuccess, onError, options) {
		Api.post(context,
			"/final-report/data"
			+ "?projectId=" + projectId
			, data
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postEmptyReport (context, projectId, onSuccess, onError, options) {
		Api.post(context,
			"/final-report/empty-report"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExportBySearchCriteria (context, contestId, projectReportExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/final-report/export-by-search-criteria"
			+ "?contestId=" + contestId
			, projectReportExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postGivePrivillages (context, projectId, userId, onSuccess, onError, options) {
		Api.post(context,
			"/final-report/give-privillages"
			+ "?projectId=" + projectId
			+ "&userId=" + userId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRepairActionCostsFromAllProjects (context, onSuccess, onError, options) {
		Api.post(context,
			"/final-report/repair-action-costs-from-all-projects"
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRequestCorrections (context, projectId, cause, onSuccess, onError, options) {
		Api.post(context,
			"/final-report/request-corrections"
			+ "?projectId=" + projectId
			+ "&cause=" + cause
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postSubmit (context, projectId, onSuccess, onError, options) {
		Api.post(context,
			"/final-report/submit"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putAccept (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/final-report/accept"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putLoadActionCostsFromProject (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/final-report/load-action-costs-from-project"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putLoadAdministrativeCostsFromProject (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/final-report/load-administrative-costs-from-project"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putReject (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/final-report/reject"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putSendForAcceptance (context, projectId, allowMainBidderChanges, finalReportDataDTO, onSuccess, onError, options) {
		Api.put(context,
			"/final-report/send-for-acceptance"
			+ "?projectId=" + projectId
			+ "&allowMainBidderChanges=" + allowMainBidderChanges
			, finalReportDataDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUndoApproval (context, projectId, onSuccess, onError, options) {
		Api.put(context,
			"/final-report/undo-approval"
			+ "?projectId=" + projectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
